export default {
    bar: {
        background: '#d8d8d8',
        keepShow: false,
        minSize: 0.12
    },
    rail: {
        size: '5px'
    },
    vuescroll: {
        detectResize: false
    }
};



// WEBPACK FOOTER //
// ./src/mixins/vueScrollConfig.js